var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Bulk Provider Quotes")]),_vm._v(" "),_c('bulk-quote-providers-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }